// @flow

const VehicleWindscreenApp = () => {
  return (
    null
  )
}

export default VehicleWindscreenApp
